<template>
  <div>
    <Breadtabsheader/>
    <div class="h-piece w-piece">
      <div class="h-pieceTitle2">
        <h1>返利测算工具-血液</h1>
      </div>
      <div class="h-pieceCon2">
        <div class="h-formLine message">
          <el-form :model="fl" label-position="right" ref="formLabelAlign" :inline="true"
                   class="demo-ruleForm h-formbLine">
            <el-form-item prop="areaCode" label="区域" class="h-elformWrap-2">
              <brselect category="YLRegion" :v="fl.areaCode" v-model="fl.areaCode"/>
            </el-form-item>
            <el-form-item label="客户" class="h-elformWrap-2" prop="customerName">
              <el-select
                  v-model="fl.customerName"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入经销商名称"
                  :remote-method="getCustomerPage"
                  :loading="loading"
                  @change="selectResult">
                <el-option
                    v-for="item in agentList"
                    :key="item.agentCode"
                    :label="item.agentName"
                    :value="item.agentName">
                </el-option>
              </el-select>
            </el-form-item>
            <br>
            <el-form-item label="测算周期" prop="radio" style="width: 50%;" class="h-elformWrap-2">
              <el-radio-group v-model="radio">
                <el-radio :label="1">月度返利</el-radio>
                <el-radio :label="2">季度返利</el-radio>
                <el-radio :label="3">年度奖励</el-radio>
              </el-radio-group>
            </el-form-item>
            <br>
          </el-form>
          <div style="width: 100%;display: flex;justify-content: center;align-items: center;margin-top: 0.2rem;">
            <div
                style="padding: 0.1rem 0.25rem;border-radius: 0.05rem;background: #2686e7;color: #fff;font-size: 0.16rem;text-align: center;cursor: pointer;"
                @click="shengcheng">测算
            </div>
          </div>
          <br>
        </div>
        <div v-if="noTarget"><span
            style="color: red;font-size: 13px">未查询到目标数据，请检查区域、经销商名称是否正确</span></div>
        <div class="h-table h-mrt30 " style="margin: 5px 0 0 5px;">
          <div v-if="cs_yue">
            <table
                style="border-collapse: collapse;width:98%; margin-bottom: 20px ;margin-top: 20px;border:none;height:25px;"
                cellspacing=0 border="1">
              <tr style="background-color: White; text-align: center; color:black;">
                <td style="width: 72px" class="h-head">周期</td>
                <td style="width: 88px" class="h-head">分类</td>
                <td style="width: 200px" class="h-head">条件</td>
                <td style="width: 72px" class="h-head">奖励系数</td>
                <td style="width: 88px" class="h-head">目标</td>
                <td style="width: 88px" class="h-head">实际</td>
                <td style="width: 88px" class="h-head">返利基数</td>
                <td style="width: 88px" class="h-head">完成率</td>
                <td style="width: 160px" class="h-head" v-if="cs_yue_fl">返利预测金额（含税）</td>
                <td style="width: 380px;" class="h-head">备注说明</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td class="h-head" rowspan="2">{{ month.month1 }}</td>
                <td class="h-text">血液网</td>
                <td class="h-text">{{ monthConditionText }}</td>
                <td class="h-text">3%</td>
                <td class="h-count">
                  <el-input v-model="monthBm.month1Goal" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');" :readonly="isReadOnly"/>
                </td>
                <td class="h-edit">
                  <el-input v-model="monthBm.month1Sales" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-edit">
                  <el-input v-model="monthBm.month1Base" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-text">{{ bmMonth1Lvyue }}</td>
                <td class="h-result" v-if="cs_yue_fl">{{ monthBm.month1Rebate }}</td>
                <td class="remark" rowspan="6">
                  1.该返利测算规则只适用于签约协议为一级经销商的客户，其他类型不适用。<br/>
                  2.填写正确的公司名称后自带出目标、销额，目标不可更改，销额、基数可进行调整，点击测算按钮进行测算。<br/>
                  3.该返利测算金额仅为预测金额，最终实际返利金额以财务测算为准。<br/>
                  4.仅供测算参考，最终解释权归青岛海尔生物医疗设备有限公司。<br/>
                  5、目标、实际、返利基数均为含税金额<br/>(单位：万元)<br/>
                  6、实际金额为OMS系统中销售样表<br/>【是否计入销额】字段“是”<br/>
                  7、返利基数为OMS系统中销售样表<br/>【是否计入基数】字段“是”<br/>
                </td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td class="h-text">传统</td>
                <td class="h-text">{{ monthConditionText }}</td>
                <td class="h-text">3%</td>
                <td class="h-count">
                  <el-input v-model="monthCm.month1Goal" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');" :readonly="isReadOnly"/>
                </td>
                <td class="h-edit">
                  <el-input v-model="monthCm.month1Sales" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-edit">
                  <el-input v-model="monthCm.month1Base" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-text">{{ cmMonth1Lvyue }}</td>
                <td class="h-result" v-if="cs_yue_fl">{{ monthCm.month1Rebate }}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td class="h-head" rowspan="2">{{ month.month2 }}</td>
                <td class="h-text">血液网</td>
                <td class="h-text">{{ monthConditionText }}</td>
                <td class="h-text">3%</td>
                <td class="h-count">
                  <el-input v-model="monthBm.month2Goal" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');" :readonly="isReadOnly"/>
                </td>
                <td class="h-edit">
                  <el-input v-model="monthBm.month2Sales" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-edit">
                  <el-input v-model="monthBm.month2Base" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-text">{{ bmMonth2Lvyue }}</td>
                <td class="h-result" v-if="cs_yue_fl">{{ monthBm.month2Rebate }}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td class="h-text">传统</td>
                <td class="h-text">{{ monthConditionText }}</td>
                <td class="h-text">3%</td>
                <td class="h-count">
                  <el-input v-model="monthCm.month2Goal" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');" :readonly="isReadOnly"/>
                </td>
                <td class="h-edit">
                  <el-input v-model="monthCm.month2Sales" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-edit">
                  <el-input v-model="monthCm.month2Base" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-text">{{ cmMonth2Lvyue }}</td>
                <td class="h-result" v-if="cs_yue_fl">{{ monthCm.month2Rebate }}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td class="h-head" rowspan="2">{{ month.month3 }}</td>
                <td class="h-text">血液网</td>
                <td class="h-text">{{ monthConditionText }}</td>
                <td class="h-text">3%</td>
                <td class="h-count">
                  <el-input v-model="monthBm.month3Goal" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');" :readonly="isReadOnly"/>
                </td>
                <td class="h-edit">
                  <el-input v-model="monthBm.month3Sales" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-edit">
                  <el-input v-model="monthBm.month3Base" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-text">{{ bmMonth3Lvyue }}</td>
                <td class="h-result" v-if="cs_yue_fl">{{ monthBm.month3Rebate }}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td class="h-text">传统</td>
                <td class="h-text">{{ monthConditionText }}</td>
                <td class="h-text">3%</td>
                <td class="h-count">
                  <el-input v-model="monthCm.month3Goal" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');" :readonly="isReadOnly"/>
                </td>
                <td class="h-edit">
                  <el-input v-model="monthCm.month3Sales" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-edit">
                  <el-input v-model="monthCm.month3Base" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-text">{{ cmMonth3Lvyue }}</td>
                <td class="h-result" v-if="cs_yue_fl">{{ monthCm.month3Rebate }}</td>
              </tr>
            </table>
          </div>
          <div v-if="cs_jidu">
            <table
                style="border-collapse: collapse;width:98%; margin-bottom: 20px ;margin-top: 20px;border:none;height:25px;"
                cellspacing=0 border="1">
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 80px" class="h-head">季度</td>
                <td style="width: 120px" class="h-head">返利类型</td>
                <td style="width: 210px" class="h-head">台阶条件</td>
                <td style="width: 90px" class="h-head">台阶系数</td>
                <td style="width: 80px" class="h-head">奖励系数</td>
                <td style="width: 100px" class="h-head">季度目标</td>
                <td style="width: 100px" class="h-head">实际</td>
                <td style="width: 100px" class="h-head">返利基数</td>
                <td style="width: 100px" class="h-head">季度完成率</td>
                <td style="width: 150px" class="h-head">返利预测金额<br/>（含税）</td>
                <td style="width: 400px" class="h-head">备注说明</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td rowspan="3" style="width: 80px" class="h-text">季度</td>
                <td style="width: 120px" class="h-text">血液网</td>
                <td style="width: 210px; text-align: left" class="h-text">15≤X&lt;30：1%；30≤X&lt;45：2%；45≤X：3%（X为季度目标，万元）</td>
                <td style="width: 90px" class="h-text">见左栏</td>
                <td style="width: 80px" class="h-text">{{ bloodPartRewardRateText(jiduBj.goal) }}</td>
                <td style="width: 100px" class="h-count">
                  <el-input v-model="jiduBj.goal" readonly/>
                </td>
                <td style="width: 100px" class="h-edit">
                  <el-input v-model="jiduBj.sales" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" class="h-edit">
                  <el-input v-model="jiduBj.base" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" class="h-text">{{ bloodLineLvyue(jiduBj.goal, jiduBj.sales) }}</td>
                <td style="width: 150px" class="h-result">{{ jidu.rebateBj }}</td>
                <td rowspan="3" style="width: 400px; text-align: left" class="remark">
                  产业季度目标完成率均≥70%；且季度整体履约率100%；且每月履约率不低于70%；返利分为三类，血液网、传统和整体奖励；传统和血液的台阶为15≤X&lt;30，1%；30≤X&lt;45，2%；45≤X，3%，各自计算各自的台阶；整体的台阶是目标≥30万×1%；目标≥45万×2%；目标≥60万×3%；目标≥75万×4%。当满足季度返利的要求时，才会根据台阶计算相应返利。
                </td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td class="h-text">传统</td>
                <td style="text-align: left" class="h-text">15≤X&lt;30：1%；30≤X&lt;45：2%；45≤X：3%（X为季度目标，万元）</td>
                <td class="h-text">见左栏</td>
                <td class="h-text">{{ bloodPartRewardRateText(jiduCj.goal) }}</td>
                <td class="h-count">
                  <el-input v-model="jiduCj.goal" readonly/>
                </td>
                <td class="h-edit">
                  <el-input v-model="jiduCj.sales" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-edit">
                  <el-input v-model="jiduCj.base" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-text">{{ bloodLineLvyue(jiduCj.goal, jiduCj.sales) }}</td>
                <td class="h-result">{{ jidu.rebateCj }}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td class="h-text">整体奖励</td>
                <td style="text-align: left" class="h-text">目标≥30万×1%；≥45万×2%；≥60万×3%；≥75万×4%（目标为血液网+传统季度目标之和，万元）</td>
                <td class="h-text">见左栏</td>
                <td class="h-text">{{ bloodOverallRewardRateText }}</td>
                <td class="h-count">
                  <el-input :value="bloodQuarterGoalSum" readonly/>
                </td>
                <td class="h-edit">
                  <el-input :value="bloodQuarterSalesSum" readonly/>
                </td>
                <td class="h-edit">
                  <el-input :value="bloodQuarterBaseSum" readonly/>
                </td>
                <td class="h-text">{{ jiduLvyue_ct }}</td>
                <td class="h-result">{{ jidu.rebateOverall }}</td>
              </tr>
              <template v-if="false">
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" rowspan="5" class="h-text">数智样本</td>
                <td style="width: 100px" class="h-text">X<20</td>
                <td style="width: 100px" class="h-text">0%</td>
                <td style="width: 100px" rowspan="5" class="h-count">
                  <el-input v-model="jidu.jichuXishuLv_ybw" readonly/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-count">
                  <el-input v-model="jidu.goal_ybw" readonly/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-edit">
                  <el-input v-model="jidu.sales_ybw" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-edit">
                  <el-input v-model="jidu.base_ybw" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-text">{{ jiduLvyue_ybw }}</td>
                <td style="width: 150px" rowspan="5" class="h-result">{{ jidu.rebate_ybw }}</td>
                <td style="width: 400px" rowspan="5" class="remark">①每季度签约销售额符合各产业季度奖励台阶<br/>②整体完成率100%及以上<br/>③归属数智样本产业的销售额完成率≥100%
                </td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">20≤X<100</td>
                <td style="width: 100px" class="h-text">1%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">100≤X<180</td>
                <td style="width: 100px" class="h-text">2%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">180≤X<300</td>
                <td style="width: 100px" class="h-text">3%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">300≤X</td>
                <td style="width: 100px" class="h-text">4%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" rowspan="5" class="h-text">智慧医疗</td>
                <td style="width: 100px" class="h-text">X<20</td>
                <td style="width: 100px" class="h-text">0%</td>
                <td style="width: 100px" rowspan="5" class="h-count">
                  <el-input v-model="jidu.jichuXishuLv_ypw" readonly/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-count">
                  <el-input v-model="jidu.goal_ypw" readonly/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-edit">
                  <el-input v-model="jidu.sales_ypw" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-edit">
                  <el-input v-model="jidu.base_ypw" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-text">{{ jiduLvyue_ypw }}</td>
                <td style="width: 150px" rowspan="5" class="h-result">{{ jidu.rebate_ypw }}</td>
                <td style="width: 400px" rowspan="5" class="remark">①每季度签约销售额符合各产业季度奖励台阶<br/>②整体完成率100%及以上<br/>③归属智慧医疗产业的销售额完成率≥100%
                </td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">20≤X<60</td>
                <td style="width: 100px" class="h-text">1%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">60≤X<120</td>
                <td style="width: 100px" class="h-text">2%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">120≤X<180</td>
                <td style="width: 100px" class="h-text">3%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">180≤X</td>
                <td style="width: 100px" class="h-text">4%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" rowspan="5" class="h-text">智慧血液</td>
                <td style="width: 100px" class="h-text">X<6</td>
                <td style="width: 100px" class="h-text">0%</td>
                <td style="width: 100px" rowspan="5" class="h-count">
                  <el-input v-model="jidu.jichuXishuLv_ND5" readonly/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-count">
                  <el-input v-model="jidu.goal_ND5" readonly/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-edit">
                  <el-input v-model="jidu.sales_ND5" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-edit">
                  <el-input v-model="jidu.base_ND5" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-text">{{ jiduLvyue_ND5 }}</td>
                <td style="width: 150px" rowspan="5" class="h-result">{{ jidu.rebate_ND5 }}</td>
                <td style="width: 400px" rowspan="5" class="remark">①每季度签约销售额符合各产业季度奖励台阶<br/>②整体完成率100%及以上<br/>③归属智慧血液产业的销售额完成率≥100%
                </td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">6≤X<30</td>
                <td style="width: 100px" class="h-text">1%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">30≤X<90</td>
                <td style="width: 100px" class="h-text">2%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">90≤X<120</td>
                <td style="width: 100px" class="h-text">3%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">120≤X</td>
                <td style="width: 100px" class="h-text">4%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" rowspan="5" class="h-text">实验室设备</td>
                <td style="width: 100px" class="h-text">X<15</td>
                <td style="width: 100px" class="h-text">0%</td>
                <td style="width: 100px" rowspan="5" class="h-count">
                  <el-input v-model="jidu.jichuXishuLv_swaq" readonly/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-count">
                  <el-input v-model="jidu.goal_swaq" readonly/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-edit">
                  <el-input v-model="jidu.sales_swaq" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-edit">
                  <el-input v-model="jidu.base_swaq" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-text">{{ jiduLvyue_swaq }}</td>
                <td style="width: 150px" rowspan="5" class="h-result">{{ jidu.rebate_swaq }}</td>
                <td style="width: 400px" rowspan="5" class="remark">①每季度签约销售额符合实验室设备产业的奖励台阶<br/>②归属实验室设备产业的销售额完成率≥100%
                </td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">15≤X<50</td>
                <td style="width: 100px" class="h-text">2%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">50≤X<90</td>
                <td style="width: 100px" class="h-text">3%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">90≤X<120</td>
                <td style="width: 100px" class="h-text">4%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">120≤X</td>
                <td style="width: 100px" class="h-text">5%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" rowspan="4" class="h-text">传统整体</td>
                <td style="width: 100px" class="h-text">X<35</td>
                <td style="width: 100px" class="h-text">0%</td>
                <td style="width: 100px" rowspan="5" class="h-count">
                  <el-input v-model="jidu.jichuXishuLv" readonly/>
                </td>
                <td style="width: 100px" rowspan="4" class="h-count">
                  <el-input v-model="jidu.goal" readonly/>
                </td>
                <td style="width: 100px" rowspan="4" class="h-edit">
                  <el-input v-model="jidu.sales" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-edit">
                  <el-input v-model="jidu.base" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan="4" class="h-text">{{ jiduLvyue_ct }}</td>
                <td style="width: 150px" rowspan="4" class="h-result">{{ jidu.rebate }}</td>
                <td style="width: 400px" rowspan="4" class="remark">①季度整体目标完成率100%及以上<br/>②季度内每月完成率均不低于70%
                </td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">35≤X<210</td>
                <td style="width: 100px" class="h-text">1%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">210≤X<410</td>
                <td style="width: 100px" class="h-text">2%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">410≤X</td>
                <td style="width: 100px" class="h-text">3%</td>
              </tr>
              </template>
            </table>
          </div>
          <div v-if="cs_jidu && (chosenField || fl.field) === 'cdwdwdgj'">
            <table
                style="border-collapse: collapse;width:98%; margin-bottom: 20px ;margin-top: 20px;border:none;height:25px;"
                cellspacing=0 border="1">
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 80px" class="h-head">季度</td>
                <td style="width: 120px" class="h-head">返利类型</td>
                <td style="width: 210px" class="h-head">台阶条件</td>
                <td style="width: 90px" class="h-head">台阶系数</td>
                <td style="width: 80px" class="h-head">奖励系数</td>
                <td style="width: 100px" class="h-head">季度同期</td>
                <td style="width: 100px" class="h-head">季度目标</td>
                <td style="width: 100px" class="h-head">实际</td>
                <td style="width: 100px" class="h-head">返利基数</td>
                <td style="width: 100px" class="h-head">季度完成率</td>
                <td style="width: 150px" class="h-head">返利预测金额<br/>（含税）</td>
                <td style="width: 400px" class="h-head">备注说明</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td class="h-text">季度</td>
                <td class="h-text">超同期奖励</td>
                <td class="h-text">签约目标&gt;同期且实际完成&gt;同期且完成率≥80%</td>
                <td class="h-text">单台阶</td>
                <td class="h-text">2%</td>
                <td class="h-count"><el-input v-model="jidu.tongqi" readonly/></td>
                <td class="h-count"><el-input v-model="jidu.goal" readonly/></td>
                <td class="h-edit">
                  <el-input v-model="jidu.sales" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-edit">
                  <el-input v-model="jidu.base" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-text">{{ jiduLvyue_ct }}</td>
                <td class="h-result">{{ jidu.rebateSuperSamePeriod }}</td>
                <td class="remark">超同期奖励：签约目标&gt;同期且实际完成&gt;同期且完成率≥80%，返利系数2%。</td>
              </tr>
            </table>
          </div>
          <div v-if="cs_jidu && (chosenField || fl.field) === 'zhyl'">
            <table
                style="border-collapse: collapse;width:98%; margin-bottom: 20px ;margin-top: 20px;border:none;height:25px;"
                cellspacing=0 border="1">
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 80px" class="h-head">季度</td>
                <td style="width: 120px" class="h-head">返利类型</td>
                <td style="width: 210px" class="h-head">台阶条件</td>
                <td style="width: 90px" class="h-head">台阶系数</td>
                <td style="width: 80px" class="h-head">奖励系数</td>
                <td style="width: 100px" class="h-head">用户等级</td>
                <td style="width: 100px" class="h-head">季度目标</td>
                <td style="width: 100px" class="h-head">实际</td>
                <td style="width: 100px" class="h-head">返利基数</td>
                <td style="width: 100px" class="h-head">季度完成率</td>
                <td style="width: 150px" class="h-head">返利预测金额<br/>（含税）</td>
                <td style="width: 400px" class="h-head">备注说明</td>
              </tr>
              <tr v-for="(stage, index) in levelAccelerateStages"
                  :key="'level_acc_stage_' + index"
                  style="background-color: White; text-align: center; color:black;height:30px;">
                <td v-if="index === 0" :rowspan="levelAccelerateStages.length" class="h-text">季度</td>
                <td v-if="index === 0" :rowspan="levelAccelerateStages.length" class="h-text">等级加速奖励</td>
                <td class="h-text">{{ stage.condition }}</td>
                <td class="h-text">{{ stage.rate }}</td>
                <td v-if="index === 0" :rowspan="levelAccelerateStages.length" class="h-text">{{ getLevelAccelerateRateText() }}</td>
                <td v-if="index === 0" :rowspan="levelAccelerateStages.length" class="h-count"><el-input :value="agentLevelText()" readonly/></td>
                <td v-if="index === 0" :rowspan="levelAccelerateStages.length" class="h-count"><el-input v-model="jidu.goal" readonly/></td>
                <td v-if="index === 0" :rowspan="levelAccelerateStages.length" class="h-edit">
                  <el-input v-model="jidu.sales" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td v-if="index === 0" :rowspan="levelAccelerateStages.length" class="h-edit">
                  <el-input v-model="jidu.base" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td v-if="index === 0" :rowspan="levelAccelerateStages.length" class="h-text">{{ jiduLvyue_ct }}</td>
                <td v-if="index === 0" :rowspan="levelAccelerateStages.length" class="h-result">{{ jidu.rebateLevelAccelerate }}</td>
                <td v-if="index === 0" :rowspan="levelAccelerateStages.length" class="remark">
                  等级加速奖励：A类客户 季度实际基数*4%；B类客户 季度实际基数*3%；C类客户 季度实际基数*1%；新开客户 季度实际基数*3%。
                </td>
              </tr>
            </table>
          </div>
          <div v-if="cs_year">
            <table
                style="border-collapse: collapse;width:98%; margin-bottom: 20px ;margin-top: 20px;border:none;height:25px;"
                cellspacing=0 border="1">
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-head">周期</td>
                <td style="width: 120px" class="h-head">类型</td>
                <td style="width: 120px" class="h-head">年度目标<br/>（万元）</td>
                <td style="width: 120px" class="h-head">年度实际<br/>（万元）</td>
                <td style="width: 110px" class="h-head">年度完成率</td>
                <td style="width: 120px" class="h-head">返利基数</td>
                <td style="width: 90px" class="h-head">返利系数</td>
                <td style="width: 130px" class="h-head">返利预测<br/>（含税）</td>
                <td style="width: 420px" class="h-head">备注说明</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td rowspan="3" class="h-text">年度</td>
                <td class="h-text">智慧血液产业</td>
                <td class="h-count">
                  <el-input v-model="annualNd5.goalYear" readonly/>
                </td>
                <td class="h-edit">
                  <el-input v-model="annualNd5.salesYear" maxlength="12"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-text">{{ bloodAnnualNd5LvyueText }}</td>
                <td class="h-edit">
                  <el-input v-model="annualNd5.base" maxlength="12"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-text">1%</td>
                <td class="h-result">{{ bloodAnnualLineRebateNd5 }}</td>
                <td rowspan="3" class="remark" style="text-align: left">
                  智慧血液产业、传统产品两条线各自年度完成率均≥80%。满足条件时返利预测为各线返利基数合计×1%。
                </td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td class="h-text">传统产品</td>
                <td class="h-count">
                  <el-input v-model="annualBct.goalYear" readonly/>
                </td>
                <td class="h-edit">
                  <el-input v-model="annualBct.salesYear" maxlength="12"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-text">{{ bloodAnnualBctLvyueText }}</td>
                <td class="h-edit">
                  <el-input v-model="annualBct.base" maxlength="12"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-text">1%</td>
                <td class="h-result">{{ bloodAnnualLineRebateBct }}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td class="h-text">整体</td>
                <td class="h-text">{{ bloodAnnualGoalSum }}</td>
                <td class="h-text">{{ bloodAnnualSalesSum }}</td>
                <td class="h-text">{{ bloodAnnualOverallLvyueText }}</td>
                <td class="h-text">{{ bloodAnnualBaseSum }}</td>
                <td class="h-text">1%</td>
                <td class="h-result">{{ bloodAnnualGrossRebate }}</td>
              </tr>
              <tr v-if="!bloodAnnualRebateEligible" style="background-color: White; text-align: center; color:black;height:30px;">
                <td colspan="9" class="remark" style="text-align: left; color: #c00">
                  当前不满足「两条线各自年度完成率均≥80%」或分线年度目标缺失，返利预测为 0。
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div style="text-align: center" v-if="fl_cesuan">
          <br/>
          <el-button class="h-btn h-bBtn h-bggreen" @click="flRebateCalculate()">返利测算</el-button>
          <br/>
          <br/>
          <br/>
        </div>
        <div class="yx_progressBar" v-if="result_jidu || result_month || result_year">
          <div class="yx_topTip">
            <div class="leftdes" v-if="result_month">
              <el-row type="flex" style="flex-wrap: wrap;width:100%">
                <el-col :span="3">
                  <span>月度返利：</span>
                </el-col>
                <el-col :span="21">
                  <span>{{ month.month1 }} 血液网 {{ monthBm.month1Rebate }} / 传统 {{ monthCm.month1Rebate }}；</span>
                  <span>{{ month.month2 }} 血液网 {{ monthBm.month2Rebate }} / 传统 {{ monthCm.month2Rebate }}；</span>
                  <span>{{ month.month3 }} 血液网 {{ monthBm.month3Rebate }} / 传统 {{ monthCm.month3Rebate }}</span>
                </el-col>
              </el-row>
            </div>
            <br/>
            <div class="leftdes" v-if="result_jidu">
              <el-row type="flex" style="flex-wrap: wrap;width:100%">
                <el-col :span="3">
                  <span>季度奖励：</span>
                </el-col>
                <el-col :span="21">
                  <span>血液网 {{ jidu.rebateBj }} / 传统 {{ jidu.rebateCj }} / 整体 {{ jidu.rebateOverall }}；合计 {{ jidu.rebateBaseTotal }}</span>
                </el-col>
              </el-row>
              <el-row v-if="(chosenField || fl.field) === 'cdwdwdgj'" type="flex" style="flex-wrap: wrap;width:100%;margin-top: 0.08rem;">
                <el-col :span="3">
                  <span>超同期奖励：</span>
                </el-col>
                <el-col :span="2">
                  {{ jidu.rebateSuperSamePeriod }}
                </el-col>
                <el-col :span="19"></el-col>
              </el-row>
              <el-row v-if="(chosenField || fl.field) === 'zhyl'" type="flex" style="flex-wrap: wrap;width:100%;margin-top: 0.08rem;">
                <el-col :span="3">
                  <span>等级加速奖励：</span>
                </el-col>
                <el-col :span="2">
                  {{ jidu.rebateLevelAccelerate }}
                </el-col>
                <el-col :span="19"></el-col>
              </el-row>
            </div>
            <div class="leftdes" v-if="result_year">
              <el-row type="flex" style="flex-wrap: wrap;width:100%">
                <el-col :span="3">
                  <span>年度奖励：</span>
                </el-col>
                <el-col :span="4">
                  {{ annualRebateAmount }}
                </el-col>
                <el-col :span="17"></el-col>
              </el-row>
            </div>
            <br/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import nc from '../../../utils/numberCalc';
import ss from '../../../api/SystemService';

/** 血液版固定传递后端的链群/领域编码 */
const BLOOD_FIELD = 'BLOOD';

export default {
  components: {},
  data() {
    return {
      loading: false,
      cs_yue: false,
      cs_jidu: false,
      cs_year: false,
      cs_yue_fl: false,
      fl_cesuan: false,
      result_month: false,
      result_jidu: false,
      result_year: false,
      result_all: false,
      radio: 1,
      chooseRadio: 1,
      isReadOnly: false,
      noTarget: false,
      // 本次“测算”生效的链群快照；只有点击“测算”后才更新，用于驱动表格显示与计算
      chosenField: null,
      fieldOptions: [
        {value: BLOOD_FIELD, label: '血液'}
      ],
      agentList: [],
      state: false,
      fl: {
        customerName: null,
        field: BLOOD_FIELD,
        areaCode: null,
      },
      month: {
        month1: null,
        month2: null,
        month3: null,
        monthXishu: 0.03,
        monthXishuFx: 0.05,
        month1Goal: 0,
        month2Goal: 0,
        month3Goal: 0,
        month1Sales: null,
        month2Sales: null,
        month3Sales: null,
        month1Base: null,
        month2Base: null,
        month3Base: null,
        month1Lvyue: 0.00,
        month2Lvyue: 0.00,
        month3Lvyue: 0.00,
        month1Rebate: 0.00,
        month2Rebate: 0.00,
        month3Rebate: 0.00,
        month1BaseFx: 0.00,
        month2BaseFx: 0.00,
        month3BaseFx: 0.00,
        month1RebateFx: 0.00,
        month2RebateFx: 0.00,
        month3RebateFx: 0.00,
        month1BaseHj: 0,
        month2BaseHj: 0,
        month3BaseHj: 0,
        month1LvyueHj: 0.00,
        month2LvyueHj: 0.00,
        month3LvyueHj: 0.00,
        month1RebateHj: 0.00,
        month2RebateHj: 0.00,
        month3RebateHj: 0.00,
      },
      /** 月度返利-血液网（接口 type=BM） */
      monthBm: {
        month1Goal: 0,
        month2Goal: 0,
        month3Goal: 0,
        month1Sales: null,
        month2Sales: null,
        month3Sales: null,
        month1Base: null,
        month2Base: null,
        month3Base: null,
        month1Rebate: 0.00,
        month2Rebate: 0.00,
        month3Rebate: 0.00,
      },
      /** 月度返利-传统（接口 type=CM） */
      monthCm: {
        month1Goal: 0,
        month2Goal: 0,
        month3Goal: 0,
        month1Sales: null,
        month2Sales: null,
        month3Sales: null,
        month1Base: null,
        month2Base: null,
        month3Base: null,
        month1Rebate: 0.00,
        month2Rebate: 0.00,
        month3Rebate: 0.00,
      },
      jidu: {
        jichuXishu: 0,
        jichuXishu_ybw: 0,
        jichuXishu_ypw: 0,
        jichuXishu_swaq: 0,
        jichuXishu_ND5: 0,
        jichuXishuLv: '0%',
        jichuXishuLv_ybw: '0%',
        jichuXishuLv_ypw: '0%',
        jichuXishuLv_swaq: '0%',
        jichuXishuLv_ND5: '0%',
        sales_ybw: null,
        base_ybw: null,
        sales_ypw: null,
        base_ypw: null,
        sales_swaq: null,
        base_swaq: null,
        sales_ND5: null,
        base_ND5: null,
        sales: 0,
        base: 0,
        goal: 0,
        goal_ybw: 0,
        goal_ypw: 0,
        goal_swaq: 0,
        goal_ND5: 0,
        lvyue_ybw: 0,
        lvyue_ypw: 0,
        lvyue_swaq: 0,
        lvyue_ND5: 0,
        lvyue: 0,
        lvyueLv_ybw: null,
        lvyueLv_ypw: null,
        lvyueLv_swaq: null,
        lvyueLv_ND5: null,
        rebate: 0,
        rebate_ybw: 0,
        rebate_ypw: 0,
        rebate_swaq: 0,
        rebate_ND5: 0,
        // 基础季度返利（不含新增奖励类型）
        rebateBaseTotal: 0,
        // 超同期奖励金额
        rebateSuperSamePeriod: 0,
        // 等级加速奖励金额
        rebateLevelAccelerate: 0,
        // 辅助判定字段（可由后端返回，暂无时默认0）
        tongqi: 0,
        agentLevel: 3,
        samePeriodGoal: 0,
        samePeriodSales: 0,
        sales2025: 0,
        sales2024: 0,
        isNewCustomer: 0,
        jiduRebate: 0,
        /** 季度返利-血液网 type=BJ */
        rebateBj: 0,
        /** 季度返利-传统 type=CJ */
        rebateCj: 0,
        /** 季度返利-整体奖励 */
        rebateOverall: 0,
      },
      /** 季度返利行数据（与接口 BJ/CJ 对应） */
      jiduBj: {
        goal: 0,
        sales: 0,
        base: 0,
      },
      jiduCj: {
        goal: 0,
        sales: 0,
        base: 0,
      },
      annual: {
        totalAmount: 0,
        actualAmount: 0
      },
      /** 血液年度：getBaseByCustomer type=Y 且 lianqun=ND5（智慧血液） */
      annualNd5: {
        goalYear: 0,
        salesYear: 0,
        base: 0
      },
      /** 血液年度：type=Y 且 lianqun=BCT（传统） */
      annualBct: {
        goalYear: 0,
        salesYear: 0,
        base: 0
      },
      areaName: sessionStorage.getItem("areaName") || ''
    }
  },
  created() {
    this.setMonthTitle();
    this.localAgent();
  },
  watch: {
    jiduBj: {
      deep: true,
      handler() {
        this.syncBloodJiduQuarterTotals();
      }
    },
    jiduCj: {
      deep: true,
      handler() {
        this.syncBloodJiduQuarterTotals();
      }
    }
  },
  computed: {
    /** 整体年度目标（万元） */
    bloodAnnualGoalSum() {
      return nc.add(Number(this.annualNd5.goalYear || 0), Number(this.annualBct.goalYear || 0));
    },
    bloodAnnualSalesSum() {
      return nc.add(Number(this.annualNd5.salesYear || 0), Number(this.annualBct.salesYear || 0));
    },
    bloodAnnualBaseSum() {
      return nc.add(Number(this.annualNd5.base || 0), Number(this.annualBct.base || 0));
    },
    bloodAnnualOverallLvyueNum() {
      const g = Number(this.bloodAnnualGoalSum || 0);
      if (g <= 0) return 0;
      return Number(nc.div(Number(this.bloodAnnualSalesSum || 0), g).toFixed(4));
    },
    bloodAnnualOverallLvyueText() {
      return this.getLvyueLv(this.bloodAnnualOverallLvyueNum);
    },
    bloodAnnualNd5LvyueNum() {
      const g = Number(this.annualNd5.goalYear || 0);
      if (g <= 0) return 0;
      return Number(nc.div(Number(this.annualNd5.salesYear || 0), g).toFixed(4));
    },
    bloodAnnualNd5LvyueText() {
      return this.bloodLineLvyue(this.annualNd5.goalYear, this.annualNd5.salesYear);
    },
    bloodAnnualBctLvyueNum() {
      const g = Number(this.annualBct.goalYear || 0);
      if (g <= 0) return 0;
      return Number(nc.div(Number(this.annualBct.salesYear || 0), g).toFixed(4));
    },
    bloodAnnualBctLvyueText() {
      return this.bloodLineLvyue(this.annualBct.goalYear, this.annualBct.salesYear);
    },
    /** 智慧血液、传统两条线各自年度完成率均 ≥ 80%，且两条线均有年度目标。 */
    bloodAnnualRebateEligible() {
      const gN = Number(this.annualNd5.goalYear || 0);
      const gB = Number(this.annualBct.goalYear || 0);
      if (gN <= 0 || gB <= 0) return false;
      return this.bloodAnnualNd5LvyueNum >= 0.8 && this.bloodAnnualBctLvyueNum >= 0.8;
    },
    bloodAnnualGrossRebate() {
      if (!this.bloodAnnualRebateEligible) return 0;
      return nc.mul(this.bloodAnnualBaseSum, 0.01);
    },
    bloodAnnualLineRebateNd5() {
      if (!this.bloodAnnualRebateEligible) return 0;
      return nc.mul(Number(this.annualNd5.base || 0), 0.01);
    },
    bloodAnnualLineRebateBct() {
      if (!this.bloodAnnualRebateEligible) return 0;
      return nc.mul(Number(this.annualBct.base || 0), 0.01);
    },
    annualRebateAmount() {
      return Number(this.bloodAnnualGrossRebate || 0);
    },
    rebateTypes() {
      const effectiveField = this.chosenField || this.fl.field;
      const selected = this.fieldOptions.find(item => item.value === effectiveField);
      const baseLabel = selected ? selected.label : '返利类型';
      const types = [{key: 'base', label: baseLabel}];
      if (effectiveField === 'cdwdwdgj') {
        types.push({key: 'superSamePeriod', label: '超同期奖励'});
      }
      if (effectiveField === 'zhyl') {
        types.push({key: 'levelAccelerate', label: '等级加速奖励'});
      }
      return types;
    },
    quarterlyTypeConfigs() {
      const effectiveField = this.chosenField || this.fl.field;
      const selected = this.fieldOptions.find(item => item.value === effectiveField);
      const baseLabel = selected ? selected.label : '返利类型';
      const baseStagesByField = {
        // 超低温&低温&冻干机
        cdwdwdgj: [
          {condition: 'X<20', rate: '0%'},
          {condition: '20≤X<100', rate: '1%'},
          {condition: '100≤X<180', rate: '3%'},
          {condition: '180≤X<300', rate: '4%'},
          {condition: '300≤X', rate: '5%'}
        ],
        // 疫苗网
        ND4: [
          {condition: 'X<10', rate: '0%'},
          {condition: '10≤X<30', rate: '2%'},
          {condition: '30≤X<50', rate: '3%'},
          {condition: '50≤X<100', rate: '5%'},
          {condition: '100≤X', rate: '6%'}
        ],
        BLOOD: [
          {condition: 'X<10', rate: '0%'},
          {condition: '10≤X<30', rate: '2%'},
          {condition: '30≤X<50', rate: '3%'},
          {condition: '50≤X<100', rate: '5%'},
          {condition: '100≤X', rate: '6%'}
        ],
        // 药品网
        zhyl: [
          {condition: 'X<20', rate: '0%'},
          {condition: '20≤X<45', rate: '4%'},
          {condition: '45≤X<60', rate: '5%'},
          {condition: '60≤X<100', rate: '6%'},
          {condition: '100≤X', rate: '7%'}
        ],
        // 离心机&培养箱&生物安全
        szky: [
          {condition: 'X<20', rate: '0%'},
          {condition: '20≤X<45', rate: '4%'},
          {condition: '45≤X<60', rate: '5%'},
          {condition: '60≤X<100', rate: '6%'},
          {condition: '100≤X', rate: '7%'}
        ]
      };

      const configs = [{
        key: 'base',
        label: baseLabel,
        stages: baseStagesByField[effectiveField] || [
          {condition: 'X<20', rate: '0%'},
          {condition: '20≤X<45', rate: '4%'},
          {condition: '45≤X<60', rate: '5%'},
          {condition: '60≤X<100', rate: '6%'},
          {condition: '100≤X', rate: '7%'}
        ]
      }];

      return configs;
    },
    quarterlyTotalRows() {
      return this.quarterlyTypeConfigs.reduce((sum, item) => sum + item.stages.length, 0);
    },
    bloodQuarterGoalSum() {
      return nc.add(Number(this.jiduBj.goal || 0), Number(this.jiduCj.goal || 0));
    },
    bloodQuarterSalesSum() {
      return nc.add(Number(this.jiduBj.sales || 0), Number(this.jiduCj.sales || 0));
    },
    bloodQuarterBaseSum() {
      return nc.add(Number(this.jiduBj.base || 0), Number(this.jiduCj.base || 0));
    },
    bloodOverallRewardRateText() {
      const r = this.getBloodOverallTierRate(this.bloodQuarterGoalSum);
      return nc.mul(r, 100) + '%';
    },
    levelAccelerateStages() {
      return [
        {condition: 'A类客户：签约≥56.5万，26年签约目标＞25年实际销额＞24年实际销额', rate: '季度实际基数*4%'},
        {condition: 'B类客户：签约≥56.5万，26年签约目标＞25年实际销额', rate: '季度实际基数*3%'},
        {condition: 'C类客户：签约<56.5万', rate: '季度实际基数*1%'},
        {condition: '新开客户：26年新开合作网络', rate: '季度实际基数*3%'}
      ];
    },
    monthConditionText() {
      return '目标不小于5万且完成率100%';
    },
    bmMonth1Lvyue() {
      return this.bloodLineLvyue(this.monthBm.month1Goal, this.monthBm.month1Sales);
    },
    bmMonth2Lvyue() {
      return this.bloodLineLvyue(this.monthBm.month2Goal, this.monthBm.month2Sales);
    },
    bmMonth3Lvyue() {
      return this.bloodLineLvyue(this.monthBm.month3Goal, this.monthBm.month3Sales);
    },
    cmMonth1Lvyue() {
      return this.bloodLineLvyue(this.monthCm.month1Goal, this.monthCm.month1Sales);
    },
    cmMonth2Lvyue() {
      return this.bloodLineLvyue(this.monthCm.month2Goal, this.monthCm.month2Sales);
    },
    cmMonth3Lvyue() {
      return this.bloodLineLvyue(this.monthCm.month3Goal, this.monthCm.month3Sales);
    },
    /*月度返利计算*/
    //履约率 = 销额/目标
    month1Lvyue: function () {
      if (this.month.month1Goal && this.month.month1Sales) {
        if (this.month.month1Goal > 0 && this.month.month1Sales > 0) {
          this.month.month1Lvyue = nc.div(this.month.month1Sales, this.month.month1Goal).toFixed(4);
          return this.getLvyueLv(this.month.month1Lvyue);
        } else {
          return '0.00%';
        }
      } else {
        return null;
      }
      ;
    },
    month2Lvyue: function () {
      if (this.month.month2Goal && this.month.month2Sales) {
        if (this.month.month2Goal > 0 && this.month.month2Sales > 0) {
          this.month.month2Lvyue = nc.div(this.month.month2Sales, this.month.month2Goal).toFixed(4);
          return this.getLvyueLv(this.month.month2Lvyue);
        } else {
          return '0.00%';
        }
      } else {
        return null;
      }
      ;
    },
    month3Lvyue: function () {
      if (this.month.month3Goal && this.month.month3Sales) {
        if (this.month.month3Goal > 0 && this.month.month3Sales > 0) {
          this.month.month3Lvyue = nc.div(this.month.month3Sales, this.month.month3Goal).toFixed(4);
          return this.getLvyueLv(this.month.month3Lvyue);
        } else {
          return '0.00%';
        }
      } else {
        return null;
      }
      ;
    },
    //基数合计
    month1BaseHj: function () {
      if (this.month.month1Base) {
        this.month.month1BaseHj = nc.add(this.month.month1Base, this.month.month1BaseFx);
        return this.month.month1BaseHj;
      } else {
        return null;
      }
    },
    month2BaseHj: function () {
      if (this.month.month2Base) {
        this.month.month2BaseHj = nc.add(this.month.month2Base, this.month.month2BaseFx);
        return this.month.month2BaseHj;
      } else {
        return null;
      }
    },
    month3BaseHj: function () {
      if (this.month.month3Base) {
        this.month.month3BaseHj = nc.add(this.month.month3Base, this.month.month3BaseFx);
        return this.month.month3BaseHj;
      } else {
        return null;
      }
    },
    //合计履约率
    month1LvyueHj: function () {
      if (this.month.month1Goal && this.month.month1Sales) {
        if (this.month.month1Goal > 0 && this.month.month1Sales > 0) {
          this.month.month1LvyueHj = nc.div(this.month.month1Sales, this.month.month1Goal).toFixed(4);
          return this.getLvyueLv(this.month.month1LvyueHj);
        } else {
          return '0.00%';
        }
      } else {
        return null;
      }
      ;
    },
    month2LvyueHj: function () {
      if (this.month.month2Goal && this.month.month2Sales) {
        if (this.month.month2Goal > 0 && this.month.month2Sales > 0) {
          this.month.month2LvyueHj = nc.div(this.month.month2Sales, this.month.month2Goal).toFixed(4);
          return this.getLvyueLv(this.month.month2LvyueHj);
        } else {
          return '0.00%';
        }
      } else {
        return null;
      }
      ;
    },
    month3LvyueHj: function () {
      if (this.month.month3Goal && this.month.month3Sales) {
        if (this.month.month3Goal > 0 && this.month.month3Sales > 0) {
          this.month.month3LvyueHj = nc.div(this.month.month3Sales, this.month.month3Goal).toFixed(4);
          return this.getLvyueLv(this.month.month3LvyueHj);
        } else {
          return '0.00%';
        }
      } else {
        return null;
      }
      ;
    },
    /*季度返利计算*/
    //季度基数
    jiduBase: function () {
      this.jidu.base = nc.add(this.jidu.base_ybw, this.jidu.base_ypw, this.jidu.base_swaq, this.jidu.base_ND5);
      return this.jidu.base;
    },
    //季度履约率
    jiduLvyue_ybw: function () {
      this.jidu.lvyue_ybw = this.jidu.goal_ybw > 0 ? nc.div(this.jidu.sales_ybw, this.jidu.goal_ybw).toFixed(4) : 0;
      return this.getLvyueLv(this.jidu.lvyue_ybw);
    },
    jiduLvyue_ypw: function () {
      this.jidu.lvyue_ypw = this.jidu.goal_ypw > 0 ? nc.div(this.jidu.sales_ypw, this.jidu.goal_ypw).toFixed(4) : 0;
      return this.getLvyueLv(this.jidu.lvyue_ypw);
    },
    jiduLvyue_swaq: function () {
      this.jidu.lvyue_swaq = this.jidu.goal_swaq > 0 ? nc.div(this.jidu.sales_swaq, this.jidu.goal_swaq).toFixed(4) : 0;
      return this.getLvyueLv(this.jidu.lvyue_swaq);
    },
    jiduLvyue_ND5: function () {
      this.jidu.lvyue_ND5 = this.jidu.goal_ND5 > 0 ? nc.div(this.jidu.sales_ND5, this.jidu.goal_ND5).toFixed(4) : 0;
      return this.getLvyueLv(this.jidu.lvyue_ND5);
    },
    jiduLvyue_ct: function () {
      this.jidu.lvyue = this.jidu.goal > 0 ? nc.div(this.jidu.sales, this.jidu.goal).toFixed(4) : 0;
      return this.getLvyueLv(this.jidu.lvyue);
    },
  },
  methods: {
    // changeArea(obj){
    //   if(obj){
    //     sessionStorage.removeItem('areaName')
    //   }
    // },
    setResultFalse() {
      this.result_month = false;
      this.result_jidu = false;
      this.result_year = false;
    },
    /** 血液网/传统 行完成率展示 */
    bloodLineLvyue(goal, sales) {
      const g = Number(goal);
      const s = Number(sales);
      if (!g || g <= 0) return '0.00%';
      if (sales === null || sales === undefined || sales === '') return '0.00%';
      const lv = nc.div(s, g).toFixed(4);
      return this.getLvyueLv(lv);
    },
    /** 行履约率数值（0~1），无目标时返回 null（不参与门槛比较） */
    bloodLineLvyueNum(goal, sales) {
      const g = Number(goal);
      if (!g || g <= 0) return null;
      if (sales === null || sales === undefined || sales === '') return 0;
      return Number(nc.div(Number(sales), g).toFixed(4));
    },
    /** 血液/传统单线台阶系数：15≤X<30→1%；30≤X<45→2%；45≤X→3%；X<15→0 */
    getBloodPartTierRate(goalWan) {
      const g = Number(goalWan) || 0;
      if (g < 15) return 0;
      if (g < 30) return 0.01;
      if (g < 45) return 0.02;
      return 0.03;
    },
    bloodPartRewardRateText(goalWan) {
      const r = this.getBloodPartTierRate(goalWan);
      return nc.mul(r, 100) + '%';
    },
    /** 整体台阶系数：目标(万)≥75→4%；≥60→3%；≥45→2%；≥30→1%；否则0 */
    getBloodOverallTierRate(goalSumWan) {
      const g = Number(goalSumWan) || 0;
      if (g >= 75) return 0.04;
      if (g >= 60) return 0.03;
      if (g >= 45) return 0.02;
      if (g >= 30) return 0.01;
      return 0;
    },
    /**
     * 季度返利前提：BJ/CJ 季度完成率均≥70%；季度整体履约率100%；
     * BM、CM 三个月在「有月度目标」时履约率均≥70%
     */
    bloodQuarterlyRebateEligible() {
      const gBj = Number(this.jiduBj.goal || 0);
      const sBj = Number(this.jiduBj.sales || 0);
      const gCj = Number(this.jiduCj.goal || 0);
      const sCj = Number(this.jiduCj.sales || 0);
      if (gBj <= 0 || gCj <= 0) return false;
      const rBj = Number(nc.div(sBj, gBj).toFixed(4));
      const rCj = Number(nc.div(sCj, gCj).toFixed(4));
      if (rBj < 0.7 || rCj < 0.7) return false;
      if (Number(this.jidu.lvyue) < 1) return false;
      const pairs = [
        [this.monthBm.month1Goal, this.monthBm.month1Sales],
        [this.monthBm.month2Goal, this.monthBm.month2Sales],
        [this.monthBm.month3Goal, this.monthBm.month3Sales],
        [this.monthCm.month1Goal, this.monthCm.month1Sales],
        [this.monthCm.month2Goal, this.monthCm.month2Sales],
        [this.monthCm.month3Goal, this.monthCm.month3Sales]
      ];
      for (let i = 0; i < pairs.length; i++) {
        const num = this.bloodLineLvyueNum(pairs[i][0], pairs[i][1]);
        if (num != null && num < 0.7) return false;
      }
      return true;
    },
    syncBloodJiduQuarterTotals() {
      if (this.fl.field !== BLOOD_FIELD) return;
      this.jidu.goal = nc.add(Number(this.jiduBj.goal || 0), Number(this.jiduCj.goal || 0));
      this.jidu.sales = nc.add(Number(this.jiduBj.sales || 0), Number(this.jiduCj.sales || 0));
      this.jidu.base = nc.add(Number(this.jiduBj.base || 0), Number(this.jiduCj.base || 0));
    },
    jiduRebateBlood() {
      this.jidu.rebate_ybw = 0;
      this.jidu.rebate_ypw = 0;
      this.jidu.rebate_swaq = 0;
      this.jidu.rebate_ND5 = 0;
      this.jidu.rebate = 0;
      this.jidu.rebateSuperSamePeriod = 0;
      this.jidu.rebateLevelAccelerate = 0;
      this.jidu.rebateBj = 0;
      this.jidu.rebateCj = 0;
      this.jidu.rebateOverall = 0;
      const rPartBj = this.getBloodPartTierRate(this.jiduBj.goal);
      const rPartCj = this.getBloodPartTierRate(this.jiduCj.goal);
      const goalSum = nc.add(Number(this.jiduBj.goal || 0), Number(this.jiduCj.goal || 0));
      const rOverall = this.getBloodOverallTierRate(goalSum);
      this.jidu.jichuXishu = rPartBj;
      this.jidu.jichuXishuLv = nc.mul(rPartBj, 100) + '%';
      const eligible = this.bloodQuarterlyRebateEligible();
      if (!eligible) {
        this.jidu.rebateBaseTotal = 0;
        this.jidu.jiduRebate = 0;
        return;
      }
      this.jidu.rebateBj = nc.mul(Number(this.jiduBj.base || 0), rPartBj);
      this.jidu.rebateCj = nc.mul(Number(this.jiduCj.base || 0), rPartCj);
      const baseSum = nc.add(Number(this.jiduBj.base || 0), Number(this.jiduCj.base || 0));
      this.jidu.rebateOverall = nc.mul(baseSum, rOverall);
      this.jidu.rebateBaseTotal = nc.add(this.jidu.rebateBj, this.jidu.rebateCj, this.jidu.rebateOverall);
      this.jidu.jiduRebate = this.jidu.rebateBaseTotal;
    },
    /** 接口月度基数写入 BM/CM（type=BM/CM, agentType=yjjxs） */
    mapBloodMonthBase(element, slot) {
      const m = String(element.month);
      if (m === '1' || m === '4' || m === '7' || m === '10') {
        slot.month1Base = element.base;
      } else if (m === '2' || m === '5' || m === '8' || m === '11') {
        slot.month2Base = element.base;
      } else if (m === '3' || m === '6' || m === '9' || m === '12') {
        slot.month3Base = element.base;
      }
    },
    /**
     * 按当前链群「季度台阶」配置，由季度签约目标(万元)取基础返利系数（与 quarterlyTypeConfigs 一致）
     */
    getQuarterlyBaseRateByField(field, goalVal) {
      // 优先使用本次测算锁定的链群
      const effectiveField = this.chosenField || field;
      const g = Number(goalVal) || 0;
      if (effectiveField === 'cdwdwdgj') {
        if (g < 20) return 0;
        if (g < 100) return 0.01;
        if (g < 180) return 0.03;
        if (g < 300) return 0.04;
        return 0.05;
      }
      if (effectiveField === 'BLOOD') {
        // 与疫苗网（ND4）季度台阶一致
        if (g < 10) return 0;
        if (g < 30) return 0.02;
        if (g < 50) return 0.03;
        if (g < 100) return 0.05;
        return 0.06;
      }
      if (effectiveField === 'ND4') {
        if (g < 10) return 0;
        if (g < 30) return 0.02;
        if (g < 50) return 0.03;
        if (g < 100) return 0.05;
        return 0.06;
      }
      if (effectiveField === 'zhyl' || effectiveField === 'szky') {
        if (g < 20) return 0;
        if (g < 45) return 0.04;
        if (g < 60) return 0.05;
        if (g < 100) return 0.06;
        return 0.07;
      }
      return this.getJiduJichuXishu(g, 'ct') || 0;
    },
    getCdwdStageConditionText(goalVal) {
      const g = Number(goalVal) || 0;
      if (g < 20) return 'X<20';
      if (g < 100) return '20≤X<100';
      if (g < 180) return '100≤X<180';
      if (g < 300) return '180≤X<300';
      return '300≤X';
    },
    //季度基础系数
    getJiduJichuXishu(goal, cy) {
      if ('ct' == cy) {
        if (goal >= 410) {
          return 0.03;
        } else if (goal >= 210) {
          return 0.02;
        } else if (goal >= 35) {
          return 0.01;
        } else {
          return 0;
        }
      } else if ('szyb' == cy) {
        if (goal >= 300) {
          return 0.04;
        } else if (goal >= 180) {
          return 0.03;
        } else if (goal >= 100) {
          return 0.02;
        } else if (goal >= 20) {
          return 0.01;
        } else {
          return 0;
        }
      } else if ('zhyl' == cy) {
        if (goal >= 180) {
          return 0.04;
        } else if (goal >= 120) {
          return 0.03;
        } else if (goal >= 60) {
          return 0.02;
        } else if (goal >= 20) {
          return 0.01;
        } else {
          return 0;
        }
      } else if ('zhxy' == cy) {
        if (goal >= 120) {
          return 0.04;
        } else if (goal >= 90) {
          return 0.03;
        } else if (goal >= 30) {
          return 0.02;
        } else if (goal >= 6) {
          return 0.01;
        } else {
          return 0;
        }
      } else if ('syssb' == cy) {
        if (goal >= 120) {
          return 0.05;
        } else if (goal >= 90) {
          return 0.04;
        } else if (goal >= 50) {
          return 0.03;
        } else if (goal >= 15) {
          return 0.02;
        } else {
          return 0;
        }
      }
    },
    //履约率%
    getLvyueLv(lvyue) {
      return nc.mul(lvyue, 100).toFixed(2) + '%';
    },
    getQuarterlyTypeAmount(typeKey) {
      if (typeKey === 'base') {
        return this.jidu.rebateBaseTotal;
      }
      if (typeKey === 'superSamePeriod') {
        return this.jidu.rebateSuperSamePeriod;
      }
      if (typeKey === 'levelAccelerate') {
        return this.jidu.rebateLevelAccelerate;
      }
      return 0;
    },
    getLevelAccelerateRateText() {
      const effectiveField = this.chosenField || this.fl.field;
      if (effectiveField !== 'zhyl') return '/';
      const level = Number(this.jidu.agentLevel);
      // 后端确认枚举：0=A，1=B，2=C，3=新开
      if (level === 0) return '4%';
      if (level === 1) return '3%';
      if (level === 2) return '1%';
      if (level === 3) return '3%';
      return '0%';
    },
    agentLevelText() {
      const level = Number(this.jidu.agentLevel);
      // 后端确认枚举：0=A，1=B，2=C，3=新开
      if (level === 0) return 'A级';
      if (level === 1) return 'B级';
      if (level === 2) return 'C级';
      if (level === 3) return '新开';
      return '/';
    },
    setMonthTitle() {
      //设置月份
      const date = new Date();
      const currentMonth = date.getMonth() + 1
      if (currentMonth == 1 || currentMonth == 4 || currentMonth == 7 || currentMonth == 10) {
        this.month.month1 = currentMonth + '月';
        this.month.month2 = (currentMonth + 1) + '月';
        this.month.month3 = (currentMonth + 2) + '月';
      } else if (currentMonth == 2 || currentMonth == 5 || currentMonth == 8 || currentMonth == 11) {
        this.month.month2 = currentMonth + '月';
        this.month.month3 = (currentMonth + 1) + '月';
        this.month.month1 = (currentMonth - 1) + '月';
      } else if (currentMonth == 3 || currentMonth == 6 || currentMonth == 9 || currentMonth == 12) {
        this.month.month3 = currentMonth + '月';
        this.month.month2 = (currentMonth - 1) + '月';
        this.month.month1 = (currentMonth - 2) + '月';
      }
    },
    selectFlInfoByAgent() {
      if (this.fl.customerName && this.fl.areaCode) {
        this.setZero();
        this.noTarget = false;
        this.getTargetByCustomer();
        if (!this.noTarget) {
          this.getBaseByCustomer();
        }
      }
    },
    //销额基数设置0
    setZero() {
      this.setMonthZero();
      this.setJiduZero();
      this.setAnnualBloodZero();
    },
    setAnnualBloodZero() {
      this.annualNd5.goalYear = 0;
      this.annualNd5.salesYear = 0;
      this.annualNd5.base = 0;
      this.annualBct.goalYear = 0;
      this.annualBct.salesYear = 0;
      this.annualBct.base = 0;
    },
    setMonthZero() {
      //月度
      this.month.month1Goal = 0;
      this.month.month2Goal = 0;
      this.month.month3Goal = 0;
      this.month.month1Sales = 0;
      this.month.month2Sales = 0;
      this.month.month3Sales = 0;
      this.month.month1Base = 0;
      this.month.month2Base = 0;
      this.month.month3Base = 0;
      this.month.month1BaseFx = 0;
      this.month.month2BaseFx = 0;
      this.month.month3BaseFx = 0;
      this.month.month1Rebate = 0;
      this.month.month2Rebate = 0;
      this.month.month3Rebate = 0;
      this.month.month1RebateHj = 0;
      this.month.month2RebateHj = 0;
      this.month.month3RebateHj = 0;
      this.month.month1RebateFx = 0;
      this.month.month2RebateFx = 0;
      this.month.month3RebateFx = 0;
      const keys = ['month1Goal', 'month2Goal', 'month3Goal', 'month1Sales', 'month2Sales', 'month3Sales',
        'month1Base', 'month2Base', 'month3Base', 'month1Rebate', 'month2Rebate', 'month3Rebate'];
      keys.forEach((k) => {
        const v = (k.indexOf('Sales') >= 0 || k.indexOf('Base') >= 0) ? null : 0;
        this.monthBm[k] = v;
        this.monthCm[k] = v;
      });
    },
    setJiduZero() {
      //季度
      this.jidu.goal_ybw = 0;
      this.jidu.goal_ypw = 0;
      this.jidu.goal_swaq = 0;
      this.jidu.goal_ND5 = 0;
      this.jidu.goal = 0;
      this.jidu.sales_ybw = 0;
      this.jidu.sales_ypw = 0;
      this.jidu.sales_swaq = 0;
      this.jidu.sales_ND5 = 0;
      this.jidu.sales = 0;
      this.jidu.base_ybw = 0;
      this.jidu.base_ypw = 0;
      this.jidu.base_swaq = 0;
      this.jidu.base_ND5 = 0;
      this.jidu.base = 0;
      this.jidu.tongqi = 0;
      this.jidu.agentLevel = 3;
      this.jidu.rebate_ybw = 0;
      this.jidu.rebate_ypw = 0;
      this.jidu.rebate_swaq = 0;
      this.jidu.rebate_ND5 = 0;
      this.jidu.rebate = 0;
      this.jidu.rebateBaseTotal = 0;
      this.jidu.rebateSuperSamePeriod = 0;
      this.jidu.rebateLevelAccelerate = 0;
      this.jidu.rebateBj = 0;
      this.jidu.rebateCj = 0;
      this.jidu.rebateOverall = 0;
      this.jidu.jiduRebate = 0;
      this.jiduBj.goal = 0;
      this.jiduBj.sales = 0;
      this.jiduBj.base = 0;
      this.jiduCj.goal = 0;
      this.jiduCj.sales = 0;
      this.jiduCj.base = 0;
      this.annual.totalAmount = 0;
      this.annual.actualAmount = 0;
    },
    //查询目标、销额
    getTargetByCustomer() {
      ss.fanli.getTargetByCustomer(this.fl.customerName, this.fl.areaCode, this.fl.field).then(rd => {
        if (this.fl.field === BLOOD_FIELD) {
          if (rd.obj && rd.obj.length > 0) {
            console.log("查询目标(BLOOD BM/CM)：", rd.obj);
            this.isReadOnly = true;
            const bm = rd.obj.find(x => String(x.type) === 'BM');
            const cm = rd.obj.find(x => String(x.type) === 'CM');
            if (!bm && !cm) {
              this.noTarget = true;
              return;
            }
            this.noTarget = false;
            const fill = (row, slot) => {
              if (!row) return;
              slot.month1Goal = row.goal1;
              slot.month2Goal = row.goal2;
              slot.month3Goal = row.goal3;
              slot.month1Sales = row.sales1;
              slot.month2Sales = row.sales2;
              slot.month3Sales = row.sales3;
            };
            fill(bm, this.monthBm);
            fill(cm, this.monthCm);
            const tqBm = bm && bm.tongqi != null && bm.tongqi !== '' ? Number(bm.tongqi) : null;
            const tqCm = cm && cm.tongqi != null && cm.tongqi !== '' ? Number(cm.tongqi) : null;
            this.jidu.tongqi = tqBm != null ? tqBm : (tqCm != null ? tqCm : 0);
            const alBm = bm && bm.agentLevel != null && bm.agentLevel !== '' ? Number(bm.agentLevel) : null;
            const alCm = cm && cm.agentLevel != null && cm.agentLevel !== '' ? Number(cm.agentLevel) : null;
            this.jidu.agentLevel = alBm != null ? alBm : (alCm != null ? alCm : 3);
            const bj = rd.obj.find(x => String(x.type) === 'BJ');
            const cj = rd.obj.find(x => String(x.type) === 'CJ');
            this.jiduBj.goal = bj ? Number(bj.goal4 || 0) : 0;
            this.jiduBj.sales = bj ? Number(bj.sales4 || 0) : 0;
            this.jiduCj.goal = cj ? Number(cj.goal4 || 0) : 0;
            this.jiduCj.sales = cj ? Number(cj.sales4 || 0) : 0;
            this.jidu.goal = nc.add(this.jiduBj.goal, this.jiduCj.goal);
            this.jidu.sales = nc.add(this.jiduBj.sales, this.jiduCj.sales);
            this.jidu.jichuXishu = 0;
            this.jidu.jichuXishuLv = '-';
          } else {
            this.noTarget = true;
          }
          return;
        }
        if (rd.obj && rd.obj.length > 0) {
          console.log("查询目标：", rd.obj)
          this.isReadOnly = true;
          //初始化目标销额为0
          let quarterFromType1 = false;
          for (const element of rd.obj) {
            var goal = element;
            if (goal.type == '1') {
              this.month.month1Goal = goal.goal1;
              this.month.month2Goal = goal.goal2;
              this.month.month3Goal = goal.goal3;
              this.month.month1Sales = goal.sales1;
              this.month.month2Sales = goal.sales2;
              this.month.month3Sales = goal.sales3;
              this.jidu.tongqi = goal.tongqi == null || goal.tongqi === '' ? 0 : Number(goal.tongqi);
              this.jidu.agentLevel = goal.agentLevel == null || goal.agentLevel === '' ? 3 : Number(goal.agentLevel);
              // type=1：goal4=季度目标，sales4=季度实际
              this.jidu.goal = goal.goal4 == null || goal.goal4 === '' ? 0 : Number(goal.goal4);
              this.jidu.sales = goal.sales4 == null || goal.sales4 === '' ? 0 : Number(goal.sales4);
              quarterFromType1 = true;
              if (['cdwdwdgj', 'zhyl', 'ND4', 'szky', 'BLOOD'].includes(this.fl.field)) {
                this.jidu.jichuXishu = this.getQuarterlyBaseRateByField(this.fl.field, this.jidu.goal);
                this.jidu.jichuXishuLv = nc.mul(this.jidu.jichuXishu, 100) + '%';
              }
            } else if (goal.type == '2') {
              if (goal.lianqun == 'szyb') {
                this.jidu.goal_ybw = goal.goal4;
                this.jidu.sales_ybw = goal.sales4;
                this.jidu.jichuXishu_ybw = this.getJiduJichuXishu(this.jidu.goal_ybw, goal.lianqun);
                this.jidu.jichuXishuLv_ybw = nc.mul(this.jidu.jichuXishu_ybw, 100) + '%';
              } else if (goal.lianqun == 'zhyl') {
                this.jidu.goal_ypw = goal.goal4;
                this.jidu.sales_ypw = goal.sales4;
                this.jidu.jichuXishu_ypw = this.getJiduJichuXishu(this.jidu.goal_ypw, goal.lianqun);
                this.jidu.jichuXishuLv_ypw = nc.mul(this.jidu.jichuXishu_ypw, 100) + '%';
              } else if (goal.lianqun == 'syssb') {
                this.jidu.goal_swaq = goal.goal4;
                this.jidu.sales_swaq = goal.sales4;
                this.jidu.jichuXishu_swaq = this.getJiduJichuXishu(this.jidu.goal_swaq, goal.lianqun);
                this.jidu.jichuXishuLv_swaq = nc.mul(this.jidu.jichuXishu_swaq, 100) + '%';
              } else if (goal.lianqun == 'zhxy') {
                this.jidu.goal_ND5 = goal.goal4;
                this.jidu.sales_ND5 = goal.sales4;
                this.jidu.jichuXishu_ND5 = this.getJiduJichuXishu(this.jidu.goal_ND5, goal.lianqun);
                this.jidu.jichuXishuLv_ND5 = nc.mul(this.jidu.jichuXishu_ND5, 100) + '%';
              }
              // 无 type=1 时：按拆行汇总季度目标/销额；已有 type=1 则以 goal4/sales4 为准，不再覆盖
              if (!quarterFromType1) {
                this.jidu.goal = nc.add(this.jidu.goal_ybw, this.jidu.goal_ypw, this.jidu.goal_swaq, this.jidu.goal_ND5);
                this.jidu.sales = nc.add(this.jidu.sales_ybw, this.jidu.sales_ypw, this.jidu.sales_swaq, this.jidu.sales_ND5);
                this.jidu.jichuXishu = this.getJiduJichuXishu(this.jidu.goal, 'ct');
                this.jidu.jichuXishuLv = nc.mul(this.jidu.jichuXishu, 100) + '%';
              }
            }
          }
        } else {
          this.noTarget = true;
        }
      })
    },
    //查询基数
    getBaseByCustomer() {
      ss.fanli.getBaseByCustomer(this.fl.customerName, this.fl.areaCode, this.fl.field).then(rd => {
        if (rd.obj) {
          for (const element of rd.obj) {
            const at = (element.agentType || element.agenttype || '').toLowerCase();
            // 血液：月度基数 BM/CM 分行
            if (this.fl.field === BLOOD_FIELD && (String(element.type) === 'BM' || String(element.type) === 'CM')) {
              if (at === 'yjjxs') {
                if (String(element.type) === 'BM') {
                  this.mapBloodMonthBase(element, this.monthBm);
                } else {
                  this.mapBloodMonthBase(element, this.monthCm);
                }
              }
              continue;
            }
            if (this.fl.field === BLOOD_FIELD && (String(element.type) === 'BJ' || String(element.type) === 'CJ')) {
              if (String(element.type) === 'BJ') {
                this.jiduBj.base = element.base;
              } else {
                this.jiduCj.base = element.base;
              }
              this.jidu.base = nc.add(Number(this.jiduBj.base || 0), Number(this.jiduCj.base || 0));
              continue;
            }
            //月度
            if (element.type == '1') {
              if (element.agentType == 'yjjxs') {
                if (element.month == '1' || element.month == '4' || element.month == '7' || element.month == '10') {
                  this.month.month1Base = element.base;
                } else if (element.month == '2' || element.month == '5' || element.month == '8' || element.month == '11') {
                  this.month.month2Base = element.base;
                } else if (element.month == '3' || element.month == '6' || element.month == '9' || element.month == '1') {
                  this.month.month3Base = element.base;
                }
              } else if (element.agentType == 'fxs') {
                if (element.month == '1' || element.month == '4' || element.month == '7' || element.month == '10') {
                  this.month.month1BaseFx = element.base;
                } else if (element.month == '2' || element.month == '5' || element.month == '8' || element.month == '11') {
                  this.month.month2BaseFx = element.base;
                } else if (element.month == '3' || element.month == '6' || element.month == '9' || element.month == '1') {
                  this.month.month3BaseFx = element.base;
                }
              }
            } else if (element.type == '2') {
              if (element.lianqun == 'szyb') {
                this.jidu.base_ybw = element.base;
              } else if (element.lianqun == 'zhyl') {
                this.jidu.base_ypw = element.base;
              } else if (element.lianqun == 'syssb') {
                this.jidu.base_swaq = element.base;
              } else if (element.lianqun == 'zhxy') {
                this.jidu.base_ND5 = element.base;
              } else if (element.lianqun == 'ct') {
                this.jidu.base = element.base;
              }
            } else if (String(element.type) === 'Y' && this.fl.field === BLOOD_FIELD) {
              const fq = String(element.lianqun || element.field || '').toUpperCase();
              const slot = fq === 'ND5' ? this.annualNd5 : fq === 'BCT' ? this.annualBct : null;
              if (slot) {
                const g = (n) => Number(n || 0);
                slot.goalYear = nc.add(g(element.goal1), g(element.goal2), g(element.goal3), g(element.goal4));
                slot.salesYear = g(element.tongqi);
                slot.base = g(element.base);
              }
            }
          }
          if (this.fl.field === BLOOD_FIELD && rd.obj) {
            this.annual.actualAmount = nc.add(Number(this.annualNd5.salesYear || 0), Number(this.annualBct.salesYear || 0));
          }
        }
      })
    },
    //返利测算
    flRebateCalculate() {
      this.setResultFalse();
      this.setRebateZero();
      //月度返利计算
      if (this.chooseRadio == 1) {
        this.monthRebate();
        this.result_month = true;
      } else if (this.chooseRadio == 2) {
        this.monthRebate();
        this.result_month = true;
        //季度返利计算
        this.jiduRebate();
        this.result_jidu = true;
      } else if (this.chooseRadio == 3) {
        this.annualRebateCalculate();
        this.result_year = true;
      }
      //日志
      this.rebateLog();
    },
    annualRebateCalculate() {
      this.annual.actualAmount = Number(this.annual.actualAmount || 0);
    },
    /** 血液版：BM/CM 分行，目标≥5 万且完成率≥100% 才有返利 */
    monthRebateBloodSplit() {
      const goalMin = 5;
      const rate = this.month.monthXishu;
      const calcLine = (line) => {
        [1, 2, 3].forEach((i) => {
          const g = Number(line[`month${i}Goal`] || 0);
          const s = Number(line[`month${i}Sales`] || 0);
          const b = Number(line[`month${i}Base`] || 0);
          const lvyue = g > 0 ? Number(nc.div(s, g).toFixed(4)) : 0;
          if (g >= goalMin && lvyue >= 1) {
            line[`month${i}Rebate`] = nc.mul(b, rate);
          } else {
            line[`month${i}Rebate`] = 0.00;
          }
        });
      };
      calcLine(this.monthBm);
      calcLine(this.monthCm);
      this.month.month1RebateHj = nc.add(this.monthBm.month1Rebate, this.monthCm.month1Rebate);
      this.month.month2RebateHj = nc.add(this.monthBm.month2Rebate, this.monthCm.month2Rebate);
      this.month.month3RebateHj = nc.add(this.monthBm.month3Rebate, this.monthCm.month3Rebate);
    },
    monthRebate() {
      const effectiveField = this.chosenField || this.fl.field;
      if (effectiveField === BLOOD_FIELD) {
        this.monthRebateBloodSplit();
        return;
      }
      // 按当前页面实时输入的“目标 / 实际 / 基数 / 分销基数”重新计算三个月返利
      // 1. 不同链群的签约目标下限（按本次测算锁定的链群）
      let goalMin = 15;
      if (effectiveField === 'cdwdwdgj') {          // 超低温&低温&冻干机
        goalMin = 10;
      } else if (effectiveField === 'zhyl') {       // 药品网：只看完成率
        goalMin = 0;
      } else if (effectiveField === 'ND4') {
        goalMin = 6;
      } else if (effectiveField === 'szky') {       // 离心机&培养箱&生物安全
        goalMin = 8;
      }

      const toNum = v => Number(v || 0);

      // === 第一个月 ===
      const g1 = toNum(this.month.month1Goal);
      const s1 = toNum(this.month.month1Sales);
      const b1 = toNum(this.month.month1Base);
      const b1Fx = toNum(this.month.month1BaseFx);
      const baseHj1 = nc.add(b1, b1Fx);
      const lvyue1 = g1 > 0 ? nc.div(s1, g1).toFixed(4) : 0;
      // 同步更新“合计基数 / 合计履约率”，保证表格展示和计算一致
      this.month.month1BaseHj = baseHj1;
      this.month.month1LvyueHj = lvyue1;
      if (g1 >= goalMin && lvyue1 >= 1) {
        this.month.month1Rebate = nc.mul(baseHj1, this.month.monthXishu);
      } else {
        this.month.month1Rebate = 0.00;
      }

      // === 第二个月 ===
      const g2 = toNum(this.month.month2Goal);
      const s2 = toNum(this.month.month2Sales);
      const b2 = toNum(this.month.month2Base);
      const b2Fx = toNum(this.month.month2BaseFx);
      const baseHj2 = nc.add(b2, b2Fx);
      const lvyue2 = g2 > 0 ? nc.div(s2, g2).toFixed(4) : 0;
      this.month.month2BaseHj = baseHj2;
      this.month.month2LvyueHj = lvyue2;
      if (g2 >= goalMin && lvyue2 >= 1) {
        this.month.month2Rebate = nc.mul(baseHj2, this.month.monthXishu);
      } else {
        this.month.month2Rebate = 0.00;
      }

      // === 第三个月 ===
      const g3 = toNum(this.month.month3Goal);
      const s3 = toNum(this.month.month3Sales);
      const b3 = toNum(this.month.month3Base);
      const b3Fx = toNum(this.month.month3BaseFx);
      const baseHj3 = nc.add(b3, b3Fx);
      const lvyue3 = g3 > 0 ? nc.div(s3, g3).toFixed(4) : 0;
      this.month.month3BaseHj = baseHj3;
      this.month.month3LvyueHj = lvyue3;
      if (g3 >= goalMin && lvyue3 >= 1) {
        this.month.month3Rebate = nc.mul(baseHj3, this.month.monthXishu);
      } else {
        this.month.month3Rebate = 0.00;
      }

      // 底部“月度返利”汇总展示
      this.month.month1RebateHj = this.month.month1Rebate;
      this.month.month2RebateHj = this.month.month2Rebate;
      this.month.month3RebateHj = this.month.month3Rebate;
    },
    jiduRebate() {
      const effectiveField = this.chosenField || this.fl.field;
      if (effectiveField === 'BLOOD') {
        this.jiduRebateBlood();
        return;
      }
      const unifiedChainFields = ['cdwdwdgj', 'zhyl', 'ND4', 'szky'];
      if (unifiedChainFields.includes(effectiveField)) {
        this.jidu.rebate_ybw = 0;
        this.jidu.rebate_ypw = 0;
        this.jidu.rebate_swaq = 0;
        this.jidu.rebate_ND5 = 0;
        this.jidu.rebate = 0;
        this.jidu.jichuXishu = this.getQuarterlyBaseRateByField(effectiveField, this.jidu.goal);
        this.jidu.jichuXishuLv = nc.mul(this.jidu.jichuXishu, 100) + '%';
        if (this.jidu.lvyue >= 1) {
          this.jidu.rebateBaseTotal = nc.mul(this.jidu.base, this.jidu.jichuXishu);
        } else {
          this.jidu.rebateBaseTotal = 0;
        }
      } else {
        //样本、智慧医疗、智慧血液需要整体100%以上，自身也100%以上，可计算返利
        if (this.jidu.lvyue >= 1) {
          //数智样本
          if (this.jidu.lvyue_ybw >= 1) {
            this.jidu.rebate_ybw = nc.mul(this.jidu.base_ybw, this.jidu.jichuXishu_ybw);
          }
          //智慧医疗
          if (this.jidu.lvyue_ypw >= 1) {
            this.jidu.rebate_ypw = nc.mul(this.jidu.base_ypw, this.jidu.jichuXishu_ypw);
          }
          //智慧血液
          if (this.jidu.lvyue_ND5 >= 1) {
            this.jidu.rebate_ND5 = nc.mul(this.jidu.base_ND5, this.jidu.jichuXishu_ND5);
          }
          //传统整体
          //判断每月完成率均不低于70%
          if (this.month.month1LvyueHj >= 0.7 && this.month.month2LvyueHj >= 0.7 && this.month.month3LvyueHj >= 0.7) {
            this.jidu.rebate = nc.mul(this.jidu.base, this.jidu.jichuXishu);
          } else {
            this.jidu.rebate = 0;
          }
        } else {
          this.jidu.rebate_ybw = 0;
          this.jidu.rebate_ypw = 0;
          this.jidu.rebate_ND5 = 0;
          this.jidu.rebate = 0;
        }
        //实验室设备
        if (this.jidu.lvyue_swaq >= 1) {
          this.jidu.rebate_swaq = nc.mul(this.jidu.base_swaq, this.jidu.jichuXishu_swaq);
        } else {
          this.jidu.rebate_swaq = 0;
        }

        // 基础季度返利（原逻辑）
        this.jidu.rebateBaseTotal = nc.add(
          this.jidu.rebate_ybw,
          this.jidu.rebate_ypw,
          this.jidu.rebate_swaq,
          this.jidu.rebate_ND5,
          this.jidu.rebate
        );
      }

      // 新增：超同期奖励（仅超低温&低温&冻干机）
      if (effectiveField === 'cdwdwdgj'
        && this.jidu.goal > this.jidu.tongqi
        && this.jidu.sales > this.jidu.tongqi
        && this.jidu.lvyue >= 0.8) {
        this.jidu.rebateSuperSamePeriod = nc.mul(this.jidu.base, 0.02);
      } else {
        this.jidu.rebateSuperSamePeriod = 0;
      }

      // 新增：等级加速奖励（仅药品网）
      if (effectiveField === 'zhyl') {
        const level = Number(this.jidu.agentLevel);
        // 后端确认枚举：0=A，1=B，2=C，3=新开
        if (level === 0) {
          this.jidu.rebateLevelAccelerate = nc.mul(this.jidu.base, 0.04);
        } else if (level === 1) {
          this.jidu.rebateLevelAccelerate = nc.mul(this.jidu.base, 0.03);
        } else if (level === 2) {
          this.jidu.rebateLevelAccelerate = nc.mul(this.jidu.base, 0.01);
        } else if (level === 3) {
          this.jidu.rebateLevelAccelerate = nc.mul(this.jidu.base, 0.03);
        } else {
          this.jidu.rebateLevelAccelerate = 0;
        }
      } else {
        this.jidu.rebateLevelAccelerate = 0;
      }

      this.jidu.jiduRebate = nc.add(
        this.jidu.rebateBaseTotal,
        this.jidu.rebateSuperSamePeriod,
        this.jidu.rebateLevelAccelerate
      );
    },
    //测算日志记录
    rebateLog() {
      ss.fanli.rebateLog(this.fl.customerName, this.chooseRadio).then(rd => {
        console.log("返利测算结束")
      });
    },
    //当前登录人
    localAgent() {
      ss.fanli.localAgent().then(rd => {
        if (rd.obj) {
          this.fl.customerName = rd.obj;
        }
      });
    },
    getCustomerPage(value) {
      if (value !== '') {
        this.agentList = [];
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          ss.fanli.getCustomerPage(value).then(rd => {
            if (rd.obj) {
              this.agentList = rd.obj;
            } else {
              this.agentList = [];
            }
          })
        }, 200);
      } else {
        this.agentList = [];
      }

    },
    //选择经销商
    selectResult(value) {
      this.fl.customerName = value;
      this.fl.field = BLOOD_FIELD;
      this.noTarget = false;
      this.fl_cesuan = false;
      this.cs_yue = false;
      this.cs_jidu = false;
      this.cs_year = false;
      this.cs_yue_fl = this.cs_yue;
      this.chosenField = null;
      this.setRebateZero();
    },
    shengcheng() {
      //隐藏最后返利计算结果
      this.setResultFalse();
      this.fl_cesuan = false;
      this.cs_year = false;
      if (this.fl.customerName && this.fl.areaCode) {
        this.fl.field = BLOOD_FIELD;
        // 本次测算锁定链群快照，后续表格展示与计算都以此为准
        this.chosenField = BLOOD_FIELD;
        if (this.radio == 1) {
          this.cs_yue = true;
          this.cs_jidu = false;
          this.cs_year = false;
          this.chooseRadio = 1;
        } else if (this.radio == 2) {
          this.cs_yue = true;
          this.cs_jidu = true;
          this.cs_year = false;
          this.chooseRadio = 2;
        } else if (this.radio == 3) {
          this.cs_yue = false;
          this.cs_jidu = false;
          this.cs_year = true;
          this.chooseRadio = 3;
        }
        this.cs_yue_fl = true;
        this.fl_cesuan = true;
        this.selectFlInfoByAgent();
      } else {
        this.$msg.msge("请先选择区域、经销商");
        return;
      }
    },
    setRebateZero() {
      this.month.month1Rebate = 0;
      this.month.month1RebateFx = 0;
      this.month.month1RebateHj = 0;
      this.month.month2Rebate = 0;
      this.month.month2RebateFx = 0;
      this.month.month2RebateHj = 0;
      this.month.month3Rebate = 0;
      this.month.month3RebateFx = 0;
      this.month.month3RebateHj = 0;
      this.monthBm.month1Rebate = 0;
      this.monthBm.month2Rebate = 0;
      this.monthBm.month3Rebate = 0;
      this.monthCm.month1Rebate = 0;
      this.monthCm.month2Rebate = 0;
      this.monthCm.month3Rebate = 0;
      this.jidu.rebate_ybw = 0;
      this.jidu.rebate_ypw = 0;
      this.jidu.rebate_swaq = 0;
      this.jidu.rebate_ND5 = 0;
      this.jidu.rebate = 0;
      this.jidu.rebateBaseTotal = 0;
      this.jidu.rebateSuperSamePeriod = 0;
      this.jidu.rebateLevelAccelerate = 0;
      this.jidu.rebateBj = 0;
      this.jidu.rebateCj = 0;
      this.jidu.rebateOverall = 0;
      this.jidu.jiduRebate = 0;
      // 年度：点击“返利测算”时仅重算通算金额，不清空后台返回/前端输入值
      this.annual.totalAmount = 0;
      this.result_month = false;
      this.result_jidu = false;
      this.result_year = false;
    },
  },
  mounted() {
    if (sessionStorage.getItem("areaName")) {
      let areaName = sessionStorage.getItem("areaName")
      this.fl.areaCode = areaName.slice(0, -1)
      let cityListArr = this.$store.getters.dicts['YLRegion']
      let cityCode = cityListArr.filter((o) => o.name == this.fl.areaCode);
      this.fl.areaCode = cityCode[0].code || ''
    }
  }
}
</script>
<style scoped>
.title {
  font-size: 24px;
  font-weight: bold;
}

.remark {
  padding-left: 2px;
  font-size: 12px;
  text-align: left;
}

.condition {
  font-size: 13px;
  text-align: center;
}

.h-head {
  font-size: 15px;
  text-align: center;
  font-weight: bold;
}

.h-text {
  font-size: 14px;
  text-align: center;
}

::v-deep .h-edit .el-input .el-input__inner {
  font-size: 13px;
  text-align: center;
  width: 100%;
  color: blue;
}

.h-result {
  font-size: 14px;
  text-align: center;
  color: blue;
}

::v-deep .h-count .el-input .el-input__inner {
  font-size: 14px;
  text-align: center;
}

/* 去掉Element UI的Input边框 */
::v-deep .leftdes .el-input__inner {
  border: none !important; /* 使用 !important 来确保覆盖默认样式 */
  box-shadow: none !important;
}

/* 如果你还想要去掉聚焦时的边框 */
::v-deep .leftdes.el-input__inner:focus {
  outline: none !important;
}
</style>
<style scoped lang="scss">

.message .h-formbLine .h-elformWrap-2 {
  width: 33.3333%;
}

.tan .h-formbLine .el-form-item__label {
  width: 47%;
}

.tan .h-formbLine .el-form-item__content {
  width: 53%
}

.tan .h-formbLine .h-elformWrap-2 {
  width: 50%;
}

.tan .h-elformWrap-1 .el-form-item__label {
  width: 20%;
}

.tan .h-elformWrap-1 .el-form-item__content {
  width: 80%;
}


$ft-colorg: #21d16f; //绿色的字
$ft-coloro: #e79118; //黄色的字
$bg-colorg: #f6fffa; //绿色的背景色
$bg-coloro: #fffbf7; //黄色的背景色
$bg-colorb: #3b77fc; //蓝色
$bg-colorgrey: #c3c3c3; //灰色
.yx_progressBar {
  margin: 0.28rem 0;
  width: 100%;
  border: 1px solid $ft-colorg;
  background-color: $bg-colorg;
  padding: 0.38rem;

  .yx_topTip {

    justify-content: flex-start;
    color: #424441;
    font-size: 0.18rem;

    .leftdes {
      margin-right: 0.75rem;
    }
  }
}
</style>